import React from 'react';
import xss from 'xss';
import PropTypes from '@squiz/xaccel-prop-types';

/**
 * Function to render content that has been sanitized by the xss library
 * @param {{content: string, props}} props - The content to be rendered and any props to be passed to the div
 * @returns {JSX.Element} - The JSX element to be rendered
 */
export default function XSSSafeContent(_ref) {
  let {
    content,
    elementType = 'div',
    ...props
  } = _ref;
  // eslint-disable-next-line react/no-danger
  return /*#__PURE__*/React.createElement(elementType, {
    ...props,
    dangerouslySetInnerHTML: {
      __html: xss(content)
    }
  });
}
XSSSafeContent.propTypes = {
  content: PropTypes.string,
  elementType: PropTypes.string
};
XSSSafeContent.defaultProps = {
  content: '',
  elementType: 'div'
};